import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { setMemberCompanies } from './companyMembersSlice';
import { setInvestorCompanies } from './companyInvestorsSlice';
import type {
  DecoratedCompany,
  UndecoratedCompany,
} from '@flemingmetrics/api-client';
import { mapToKey } from '@/utils/arrays';

type CompaniesState = {
  byId: Record<string, UndecoratedCompany>;
};

const initialState: CompaniesState = { byId: {} };

export const companiesSlice = createSlice({
  name: 'companies',
  initialState,
  reducers: {
    addCompany: (state, action: PayloadAction<DecoratedCompany>) => {
      return getNextState(state, [action.payload]);
    },
    setCompanies: (state, action: PayloadAction<DecoratedCompany[]>) => {
      return getNextState(state, action.payload);
    },
    deleteCompany: (state, action: PayloadAction<{ companyId: number }>) => {
      delete state.byId[action.payload.companyId];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setMemberCompanies, (state, action) => {
      return getNextState(state, mapToKey(action.payload, 'company'));
    });
    builder.addCase(setInvestorCompanies, (state, action) => {
      return getNextState(state, mapToKey(action.payload, 'company'));
    });
  },
});

function formatCompany({ address, ...company }: DecoratedCompany) {
  return company;
}

function getNextState(state: CompaniesState, companies: DecoratedCompany[]) {
  const byId = { ...state.byId };
  companies.forEach((c) => {
    byId[c.id] = formatCompany(c);
  });
  return { byId };
}

export const { addCompany, setCompanies, deleteCompany } =
  companiesSlice.actions;

export default companiesSlice.reducer;
